import React from 'react';
import { cn } from '@/lib/utils';
import { normalizeCropMeta, isDefaultCrop } from '../../utils/avatarCrop';

/**
 * Yuvarlak avatar; crop_meta ile pan+zoom (object-fit cover).
 * @param {string} sizeClass - Tailwind boyut (örn. w-10 h-10)
 */
export default function AvatarRoundImage({ src, alt = '', sizeClass = 'w-10 h-10', cropMeta, className = '' }) {
  const c = normalizeCropMeta(cropMeta);
  const def = isDefaultCrop(c);

  if (!src) return null;

  return (
    <div
      className={cn(
        'rounded-full overflow-hidden border border-white/15 bg-black/30 shrink-0 relative',
        sizeClass,
        className
      )}
    >
      <img
        src={src}
        alt={alt}
        className={def ? 'h-full w-full object-cover' : 'absolute'}
        style={
          def
            ? undefined
            : {
                left: '50%',
                top: '50%',
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                transform: `translate(-50%, -50%) translate(${c.x * 42}%, ${c.y * 42}%) scale(${c.zoom})`,
                transformOrigin: 'center center',
              }
        }
      />
    </div>
  );
}
